module.exports = __webpack_public_path__ + "static/media/arrow-right.eb8a95d6.svg";